
export const getData = (data: any): any[] => {
  let nestedData: any = [];
  let singleData: any = [];
  let sortedSingleData: any = [];
  let sortedNestedData: any = [];
  data && data?.map((item: any) => {
    if (item?.data?.length > 0) {
      nestedData?.push(item)
    }
    else {
      singleData?.push(item)
    }
  })





  return data
}